










import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class MessageIcon extends Vue {
  hideIcon: boolean = false;

  @Watch('$route')
  onPropertyChanged(newRoute: any, oldRoute: any) {
    this.hideIcon = newRoute.name === 'message';
  }
}
